
















































import Vue from 'vue';
import { sanityClient, urlFor } from '@/config/sanity';
import SanityBlockContentModel from '@/models/sanitySchema/sanityBlockContent';
import { YearlyEvent } from '@/models/yearlyEvents';
import SanityBlockContent from '@/components/SanityBlockContent.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import SocialEventCard from '@/components/SocialEvent.vue';
import SpeakerWithGradient from '@/components/SpeakerWithGradient.vue';

interface SocialPage {
  title: string;
  content: SanityBlockContentModel;
  yearlyEvents: Array<YearlyEvent>;
  recurringEvents: Array<YearlyEvent>;
  otherEvents: Array<YearlyEvent>;
}

interface Data {
  isLoading: boolean;
  error: string;
  page: SocialPage | null;
}

export default Vue.extend({
  name: 'Social',
  components: {
    LoadingIndicator,
    ErrorMessage,
    SanityBlockContent,
    SocialEventCard,
    SpeakerWithGradient,
  },
  data(): Data {
    return {
      isLoading: true,
      error: '',
      page: null,
    };
  },
  created() {
    this.fetchPage();
  },
  methods: {
    urlFor,
    fetchSocialPage() {
      const query = `*[_type == "socialPage"]{
        "createdAt": _createdAt,
        "updatedAt": _updatedAt,
        "id": _id,
        "key": _key,
        "slug": slug.current,
        title,
        slug,
        content,
        yearlyEvents[] {
          _key,
          _createdAt,
          _updatedAt,
          title,
          description,
          dateExact,
          dateDescription,
          location,
          role->,
          type->,
          image
        },
        recurringEvents[] {
          _key,
          _createdAt,
          _updatedAt,
          title,
          description,
          dateExact,
          dateDescription,
          location,
          role->,
          type->,
          image
        },
        otherEvents[] {
          _key,
          _createdAt,
          _updatedAt,
          title,
          description,
          dateExact,
          dateDescription,
          location,
          role->,
          type->,
          image
        }
      }[0]`;

      return sanityClient.fetch(query).then(
        (page) => {
          this.page = {
            title: page.title,
            content: page.content,
            yearlyEvents: page.yearlyEvents || [],
            recurringEvents: page.recurringEvents || [],
            otherEvents: page.otherEvents || [],
          };
        },
        (error) => {
          this.error = error;
        },
      );
    },
    fetchPage() {
      this.isLoading = true;
      Promise.all([
        this.fetchSocialPage(),
      ]).then(() => {
        this.isLoading = false;
      }).catch(() => {
        this.isLoading = false;
      });
    },
  },
});
